module.exports = __webpack_public_path__ + "img/error.1ac6cbe4.svg";